import { LuTypeaheadType } from './lu-typeahead.models';

export class LuTypeaheadService {
	// any should be LuTypeaheadComponent but there is angular Dependecy warning
	constructor(private readonly typeahead: any) {}

	getSelectedObjects(): any[] {
		return this.typeahead.internalSelectedValues;
	}

	isOnline(): boolean {
		return !!this.typeahead.urlOptions;
	}

	setInitialItems(values: any[]): void {
		this.typeahead.items = values;
		this.typeahead.originalItems = values;
	}

	clearSelectedObjects(): void {
		this.typeahead.internalSelectedValues = [];
		this.typeahead.selectedValues = [];
	}

	setApiUrl(newApiUrl: string): void {
		this.typeahead.urlOptions.apiUrl = newApiUrl;
		this.typeahead.loadUrlOptions();
		this.typeahead.search(this.typeahead.input.value);
	}

	setApiUrlParams(newApiUrlParams: any): void {
		this.typeahead.urlOptions.params = newApiUrlParams;
		this.typeahead.loadUrlOptions();
		this.typeahead.search(this.typeahead.input.value);
	}

	setInitialValues(values: any[]): void {
		// After CD is done
		Promise.resolve(null).then(() => {
			values.forEach(item => {
				this.typeahead.addItem(item);
			});
			this.typeahead.onChange([...this.typeahead.selectedValues]);
		});
	}

	setSelectedValues(values: any[]): void {
		this.typeahead.selectedValues = values;
	}

	getItems(): any[] {
		return this.typeahead.items;
	}

	triggerSearch(): void {
		this.typeahead.search(this.typeahead.searchValue, false);
	}

	getSelectedItem(value: any): any {
		if (!!this.typeahead.selectAs) {
			return this.typeahead.items.find(item => item[this.typeahead.selectAs] === value);
		}
		return this.typeahead.items.find(item => item.value === value);
	}

	removeSelectedItem(itemValue: any): void {
		this.typeahead.selectedValues = this.typeahead.selectedValues.filter(item => item !== itemValue);

		if (!!this.typeahead.selectAs) {
			// tslint:disable-next-line
			this.typeahead.internalSelectedValues = this.typeahead.internalSelectedValues.filter(
				item => item[this.typeahead.selectAs] !== itemValue
			);
		}
	}

	getChipOptionsField(): string {
		const { options } = this.typeahead;
		const { chipOptions } = options;
		switch (chipOptions.type) {
			case LuTypeaheadType.PRIMARY_SECONDARY: {
				return chipOptions.primaryField.field;
			}
		}
	}
}
